import Cookies from "js-cookie";

// Carries the Cognito access token across *.letslaunch.io subdomains so
// zapflow and farm-manager's frontends can pick it up without their own
// Cognito SDK integration - they just read this cookie, use it as their
// Bearer token, and bounce back to letslaunch's login (with a `redirect`
// param) if it's missing or their backend rejects it. Deliberately
// separate from the `authInfo` cookie, which is UI/routing state only and
// must never become a real authorization input.
const SSO_COOKIE_NAME = "ll_sso_token";

export const setSsoCookie = (accessToken: string) => {
  Cookies.set(SSO_COOKIE_NAME, accessToken, {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    path: "/",
    secure: true,
    sameSite: "lax", // must survive a top-level cross-subdomain redirect
    expires: 1,
  });
};

export const clearSsoCookie = () => {
  Cookies.remove(SSO_COOKIE_NAME, {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    path: "/",
  });
};

// Only trust an explicit `redirect` param pointing at a real
// *.letslaunch.io subdomain - never an arbitrary external URL (open
// redirect).
export const getSafeRedirectTarget = (
  redirectParam: string | null
): string | null => {
  if (!redirectParam) return null;
  try {
    const target = new URL(redirectParam);
    const cookieDomain = (process.env.REACT_APP_COOKIE_DOMAIN || "").replace(/^\./, "");
    if (target.hostname === cookieDomain || target.hostname.endsWith(`.${cookieDomain}`)) {
      return target.toString();
    }
  } catch {
    // not a valid absolute URL - ignore
  }
  return null;
};
